import { useQuery } from '@tanstack/react-query';

// model
import { DatasetContentModel } from './../../models/dataset.model';

// services
import API from '../../services/api';

import queryKeys from './__queryKeys';

const getDatasetContent = async (datasetId?: number) => {
    if (!datasetId) return null;
    const { data } = await API.fetchDatasetContentById(datasetId);
    return (data?.items ?? []) as DatasetContentModel[];
};

export default function useDatasetContentQuery(datasetId?: number) {
    return useQuery({
        queryKey: queryKeys.datasetContent(datasetId),
        queryFn: () => getDatasetContent(datasetId),
        enabled: !!datasetId,
    });
}
